import { render, staticRenderFns } from "./HotelResponsePresentation.vue?vue&type=template&id=68b0f182&scoped=true&"
import script from "./HotelResponsePresentation.vue?vue&type=script&lang=js&"
export * from "./HotelResponsePresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b0f182",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VDivider,VRating,VRow,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b0f182')) {
      api.createRecord('68b0f182', component.options)
    } else {
      api.reload('68b0f182', component.options)
    }
    module.hot.accept("./HotelResponsePresentation.vue?vue&type=template&id=68b0f182&scoped=true&", function () {
      api.rerender('68b0f182', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/OfferPresentation/HotelResponsePresentation.vue"
export default component.exports